import moment from 'moment';
import React from 'react';
import TableRow from '../../../components/TableRow';
import SupportTitle from '../../../components/title';

const UserConnexion = ({user, applicationsData}) => {
  return (
    <div>
      <SupportTitle title="connexion" />
      <table className="table table-sm table-responsive table-striped">
        <thead>
          <tr>
            <th>Key</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <TableRow label="ID" value={user.id} />
          <TableRow label="From" value={user.from} />
          <TableRow
            label="Sign up date"
            value={moment(user?.createdAt).format('DD/MM/YY, HH:mm')}
          />
          <TableRow
            label="Connexion"
            value={parseInt(
              applicationsData?.totalConnections || 0,
              10,
            ).toLocaleString()}
          />
          <TableRow
            label="Last login"
            value={moment(user?.lastLogin).format('DD/MM/YY, HH:mm')}
          />
        </tbody>
      </table>
    </div>
  );
};

export default UserConnexion;



// WEBPACK FOOTER //
// ./src/pages/Support/User/components/Connexion/index.js